import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-frank', 'CurrencyFrank', [["path",{"d":"M17 5h-6a2 2 0 0 0 -2 2v12"}],["path",{"d":"M7 15h4"}],["path",{"d":"M9 11h7"}]]);